import apprenticeCombatGloves from "./items/apprentice_combat_gloves.v1.json" with { type: "json" };
import blackSteelKunai from "./items/black_steel_kunai.v1.json" with { type: "json" };
import recruitForeheadProtector from "./items/recruit_forehead_protector.v1.json" with { type: "json" };
import reinforcedFieldVest from "./items/reinforced_field_vest.v1.json" with { type: "json" };
import scoutShurikenPouch from "./items/scout_shuriken_pouch.v1.json" with { type: "json" };
import sereneFlowTalisman from "./items/serene_flow_talisman.v1.json" with { type: "json" };
import sereneMindEarring from "./items/serene_mind_earring.v1.json" with { type: "json" };
import silentStepPants from "./items/silent_step_pants.v1.json" with { type: "json" };
import spiritualPulseRing from "./items/spiritual_pulse_ring.v1.json" with { type: "json" };
import steadyPulseBracelet from "./items/steady_pulse_bracelet.v1.json" with { type: "json" };
import swiftStepSandals from "./items/swift_step_sandals.v1.json" with { type: "json" };
import wolfFang from "./items/wolf_fang.v1.json" with { type: "json" };
import bearClaw from "./items/bear_claw.v1.json" with { type: "json" };
import academySummoningScrollUncommon from "./items/academy_summoning_scroll_uncommon.v1.json" with { type: "json" };
import academySummoningScrollRare from "./items/academy_summoning_scroll_rare.v1.json" with { type: "json" };
import academySummoningScrollEpic from "./items/academy_summoning_scroll_epic.v1.json" with { type: "json" };
import academySummoningScrollLegendary from "./items/academy_summoning_scroll_legendary.v1.json" with { type: "json" };
import scrollImpactoFrontal from "./items/technique_scroll_impacto_frontal.v1.json" with { type: "json" };
import scrollLaminaDeVento from "./items/technique_scroll_lamina_de_vento.v1.json" with { type: "json" };
import scrollSeloExplosivo from "./items/technique_scroll_selo_explosivo.v1.json" with { type: "json" };
import scrollPalmaRestauradora from "./items/technique_scroll_palma_restauradora.v1.json" with { type: "json" };
import scrollIlusaoDoMedo from "./items/technique_scroll_ilusao_do_medo.v1.json" with { type: "json" };
import scrollQuedaDoTrovao from "./items/technique_scroll_queda_do_trovao.v1.json" with { type: "json" };
import scrollSeloDeProximidade from "./items/technique_scroll_selo_de_proximidade.v1.json" with { type: "json" };
import scrollCampoDeRelampagos from "./items/technique_scroll_campo_de_relampagos.v1.json" with { type: "json" };
import scrollBarreiraRestauradora from "./items/technique_scroll_barreira_restauradora.v1.json" with { type: "json" };
import scrollDefesaReflexa from "./items/technique_scroll_defesa_reflexa.v1.json" with { type: "json" };
import scrollContraGolpePreciso from "./items/technique_scroll_contra_golpe_preciso.v1.json" with { type: "json" };
import scrollDominioDasRaizes from "./items/technique_scroll_dominio_das_raizes.v1.json" with { type: "json" };
import scrollSeloDemolidor from "./items/technique_scroll_selo_demolidor.v1.json" with { type: "json" };
import scrollSeloInstavel from "./items/technique_scroll_selo_instavel.v1.json" with { type: "json" };
import scrollRupturaDasRaizes from "./items/technique_scroll_ruptura_das_raizes.v1.json" with { type: "json" };
import scrollPulsoDeEmergencia from "./items/technique_scroll_pulso_de_emergencia.v1.json" with { type: "json" };
import blackToolFragment from "./items/black_tool_fragment.v1.json" with { type: "json" };
import charredFuse from "./items/charred_fuse.v1.json" with { type: "json" };
import sealedAsh from "./items/sealed_ash.v1.json" with { type: "json" };
import slagCore from "./items/slag_core.v1.json" with { type: "json" };
import overseerInsignia from "./items/overseer_insignia.v1.json" with { type: "json" };
import blackForgeFragment from "./items/black_forge_fragment.v1.json" with { type: "json" };
import blackForgeCrest from "./items/black_forge_crest.v1.json" with { type: "json" };
import alphaWolfFang from "./items/alpha_wolf_fang.v1.json" with { type: "json" };
import ancestralHowlFragment from "./items/ancestral_howl_fragment.v1.json" with { type: "json" };
import ancestralPackTotem from "./items/ancestral_pack_totem.v1.json" with { type: "json" };
import ancestralPackFang from "./items/ancestral_pack_fang.v1.json" with { type: "json" };
import ancestralPackHide from "./items/ancestral_pack_hide.v1.json" with { type: "json" };
import ancestralHowlAmulet from "./items/ancestral_howl_amulet.v1.json" with { type: "json" };
import { RARITY_ORDER, type Rarity } from "@ninja/domain";

export const EQUIPMENT_SLOTS = [
  "weapon",
  "secondary_weapon",
  "helmet",
  "armor",
  "legs",
  "glove",
  "boots",
  "ring",
  "earring",
  "necklace",
  "bracelet",
] as const;

export type EquipmentSlot = (typeof EQUIPMENT_SLOTS)[number];

export const EQUIPMENT_PROGRESS_RARITIES = [
  "uncommon",
  "rare",
  "epic",
  "legendary",
  "mythic",
] as const;
export const EQUIPMENT_RARITIES = [
  "common",
  ...EQUIPMENT_PROGRESS_RARITIES,
] as const;
export const EQUIPMENT_TIERS = [1, 2, 3, 4] as const;
export const EQUIPMENT_MAX_ENHANCEMENT = 15;

export interface ItemQualityDefinition {
  rarities: readonly Rarity[];
  progression: {
    minTier: number;
    maxTier: number;
    maxEnhancement: number;
  };
}

export type EquipmentStat =
  | "maxHealth"
  | "maxChakra"
  | "physicalAttack"
  | "techniqueAttack"
  | "physicalDefense"
  | "techniqueDefense"
  | "critical"
  | "precision"
  | "evasion"
  | "movementSpeedPercent"
  | "attackSpeedPercent"
  | "controlPower"
  | "tenacity"
  | "criticalResistance";

export interface EquipmentAttributeDefinition {
  stat: EquipmentStat;
  value: number;
  unit: "flat" | "percent";
  /** Minimum item rarity that unlocks this native attribute. Defaults to common. */
  unlockRarity?: Rarity;
}

export interface EquipmentInstanceReference {
  itemId: string;
  definitionVersion: number;
  rarity: Rarity;
  tier: number;
  enhancementLevel: number;
}

interface ItemDefinitionBase {
  schemaVersion: 1;
  definitionVersion: number;
  id: string;
  name: string;
  description: string;
  category: "equipment" | "resource" | "material" | "consumable";
  iconKey: string;
  stacking: {
    enabled: boolean;
    maxStack: number;
    unitVolume: number;
  };
}

export interface ItemUsageDefinition {
  kind: "technique_scroll";
  techniqueId: string;
}

export interface EquipmentDefinition extends ItemDefinitionBase {
  category: "equipment";
  slot: EquipmentSlot;
  attributes: readonly EquipmentAttributeDefinition[];
  quality: ItemQualityDefinition & {
    common: { tier: 1; maxEnhancement: 0 };
  };
}

export interface GenericItemDefinition extends ItemDefinitionBase {
  category: "resource" | "material" | "consumable";
  quality?: ItemQualityDefinition;
  usage?: ItemUsageDefinition;
}

export type StackableItemDefinition = GenericItemDefinition & {
  stacking: ItemDefinitionBase["stacking"] & { enabled: true };
};

export type ItemDefinition = EquipmentDefinition | GenericItemDefinition;

const equipmentProfiles: unknown[] = [
  academySummoningScrollUncommon,
  academySummoningScrollRare,
  academySummoningScrollEpic,
  academySummoningScrollLegendary,
  scrollImpactoFrontal,
  scrollLaminaDeVento,
  scrollSeloExplosivo,
  scrollPalmaRestauradora,
  scrollIlusaoDoMedo,
  scrollQuedaDoTrovao,
  scrollSeloDeProximidade,
  scrollCampoDeRelampagos,
  scrollBarreiraRestauradora,
  scrollDefesaReflexa,
  scrollContraGolpePreciso,
  scrollDominioDasRaizes,
  scrollSeloDemolidor,
  scrollSeloInstavel,
  scrollRupturaDasRaizes,
  scrollPulsoDeEmergencia,
  blackToolFragment,
  charredFuse,
  sealedAsh,
  slagCore,
  overseerInsignia,
  blackForgeFragment,
  blackForgeCrest,
  alphaWolfFang,
  ancestralHowlFragment,
  ancestralPackTotem,
  ancestralPackFang,
  ancestralPackHide,
  ancestralHowlAmulet,
  apprenticeCombatGloves,
  bearClaw,
  blackSteelKunai,
  recruitForeheadProtector,
  reinforcedFieldVest,
  scoutShurikenPouch,
  sereneFlowTalisman,
  sereneMindEarring,
  silentStepPants,
  spiritualPulseRing,
  steadyPulseBracelet,
  swiftStepSandals,
  wolfFang,
];

const validCategories = ["equipment", "resource", "material", "consumable"];
const validStats = new Set<EquipmentStat>([
  "maxHealth",
  "maxChakra",
  "physicalAttack",
  "techniqueAttack",
  "physicalDefense",
  "techniqueDefense",
  "critical",
  "precision",
  "evasion",
  "movementSpeedPercent",
  "attackSpeedPercent",
  "controlPower",
  "tenacity",
  "criticalResistance",
]);
const EQUIPMENT_RARITY_MULTIPLIERS: Record<Rarity, number> = {
  common: 1,
  uncommon: 1.2,
  rare: 2,
  epic: 3.5,
  legendary: 6,
  mythic: 10,
};

export interface ResolvedItemQuality {
  rarities: readonly Rarity[];
  minTier: number;
  maxTier: number;
  maxEnhancement: number;
}

export function itemQualityRules(
  definition: ItemDefinition,
): ResolvedItemQuality {
  const quality = definition.quality;
  if (!quality)
    return {
      rarities: ["common"],
      minTier: 1,
      maxTier: 1,
      maxEnhancement: 0,
    };
  return {
    rarities: quality.rarities,
    minTier: quality.progression.minTier,
    maxTier: quality.progression.maxTier,
    maxEnhancement: quality.progression.maxEnhancement,
  };
}

function validateGenericQuality(
  quality: unknown,
): quality is ItemQualityDefinition {
  if (!quality || typeof quality !== "object") return false;
  const definition = quality as ItemQualityDefinition;
  return (
    Array.isArray(definition.rarities) &&
    definition.rarities.length > 0 &&
    definition.rarities.every((rarity) =>
      EQUIPMENT_RARITIES.includes(
        rarity as (typeof EQUIPMENT_RARITIES)[number],
      ),
    ) &&
    new Set(definition.rarities).size === definition.rarities.length &&
    Number.isInteger(definition.progression?.minTier) &&
    definition.progression.minTier >= 1 &&
    Number.isInteger(definition.progression.maxTier) &&
    definition.progression.maxTier >= definition.progression.minTier &&
    definition.progression.maxTier <= 4 &&
    Number.isInteger(definition.progression.maxEnhancement) &&
    definition.progression.maxEnhancement === 0
  );
}

export function parseItemDefinition(value: unknown): ItemDefinition {
  if (!value || typeof value !== "object")
    throw new TypeError("Item definition must be a JSON object");
  const item = value as Partial<ItemDefinition>;
  if (
    item.schemaVersion !== 1 ||
    typeof item.definitionVersion !== "number" ||
    !Number.isInteger(item.definitionVersion) ||
    item.definitionVersion < 1 ||
    !item.id ||
    !/^[a-z0-9_]+$/.test(item.id) ||
    !item.name ||
    !item.description ||
    !validCategories.includes(item.category ?? "") ||
    !item.iconKey ||
    !item.stacking ||
    typeof item.stacking.enabled !== "boolean" ||
    !Number.isInteger(item.stacking.maxStack) ||
    item.stacking.maxStack < 1 ||
    !Number.isFinite(item.stacking.unitVolume) ||
    item.stacking.unitVolume <= 0 ||
    (!item.stacking.enabled && item.stacking.maxStack !== 1) ||
    (item.stacking.enabled && item.stacking.maxStack < 2)
  )
    throw new TypeError("Item content has invalid identity or stacking fields");

  if (item.category === "equipment") {
    const equipment = item as EquipmentDefinition;
    if (
      !EQUIPMENT_SLOTS.includes(equipment.slot) ||
      equipment.stacking.enabled ||
      !Array.isArray(equipment.attributes) ||
      !equipment.attributes.length ||
      !equipment.quality ||
      !Array.isArray(equipment.quality.rarities) ||
      equipment.quality.rarities.length !== EQUIPMENT_RARITIES.length ||
      !equipment.quality.rarities.every(
        (rarity, index) =>
          EQUIPMENT_RARITIES.includes(rarity) &&
          rarity === EQUIPMENT_RARITIES[index],
      ) ||
      equipment.quality.common?.tier !== 1 ||
      equipment.quality.common.maxEnhancement !== 0 ||
      equipment.quality.progression?.minTier !== 1 ||
      equipment.quality.progression.maxTier !== 4 ||
      equipment.quality.progression.maxEnhancement !== 15 ||
      equipment.attributes.some(
        (attribute) =>
          !validStats.has(attribute.stat) ||
          !Number.isFinite(attribute.value) ||
          attribute.value <= 0 ||
          !["flat", "percent"].includes(attribute.unit) ||
          (attribute.unlockRarity !== undefined &&
            !EQUIPMENT_RARITIES.includes(attribute.unlockRarity)),
      )
    )
      throw new TypeError(`${equipment.id} has invalid equipment fields`);
    return equipment;
  }
  if (
    item.category === "resource" ||
    item.category === "material" ||
    item.category === "consumable"
  ) {
    if (item.quality !== undefined && !validateGenericQuality(item.quality))
      throw new TypeError(`${item.id} has invalid generic item quality`);
    if (item.usage !== undefined) {
      const usage = item.usage as ItemUsageDefinition;
      if (
        usage.kind !== "technique_scroll" ||
        !/^[a-z0-9_]{1,80}$/.test(usage.techniqueId) ||
        item.category !== "consumable" ||
        !item.stacking.enabled ||
        !item.quality ||
        item.quality.rarities.join(",") !== "uncommon,rare,epic,legendary" ||
        item.quality.progression.minTier !== 1 ||
        item.quality.progression.maxTier !== 1 ||
        item.quality.progression.maxEnhancement !== 0
      )
        throw new TypeError(`${item.id} has invalid technique scroll usage`);
    }
    return item as GenericItemDefinition;
  }
  throw new TypeError("Unsupported item category");
}

export const ITEM_DEFINITION_VERSIONS: readonly ItemDefinition[] =
  Object.freeze(equipmentProfiles.map(parseItemDefinition));

const definitionsByVersion = new Map<string, ItemDefinition>();
const definitionsById = new Map<string, ItemDefinition>();
for (const definition of ITEM_DEFINITION_VERSIONS) {
  const versionKey = `${definition.id}:${definition.definitionVersion}`;
  if (definitionsByVersion.has(versionKey))
    throw new Error(`Duplicate item definition version ${versionKey}`);
  definitionsByVersion.set(versionKey, definition);
  const latest = definitionsById.get(definition.id);
  if (!latest || latest.definitionVersion < definition.definitionVersion)
    definitionsById.set(definition.id, definition);
}

export const ITEM_DEFINITIONS: readonly ItemDefinition[] = Object.freeze([
  ...definitionsById.values(),
]);

export const EQUIPMENT_ITEMS: readonly EquipmentDefinition[] =
  ITEM_DEFINITIONS.filter(
    (item): item is EquipmentDefinition => item.category === "equipment",
  );

export function itemDefinition(itemId: string): ItemDefinition | undefined {
  return definitionsById.get(itemId);
}

export function itemDefinitionAtVersion(
  itemId: string,
  definitionVersion: number,
): ItemDefinition | undefined {
  return definitionsByVersion.get(`${itemId}:${definitionVersion}`);
}

export function equipmentDefinition(
  itemId: string,
): EquipmentDefinition | undefined {
  const definition = itemDefinition(itemId);
  return definition?.category === "equipment" ? definition : undefined;
}

export function equipmentDefinitionAtVersion(
  itemId: string,
  definitionVersion: number,
): EquipmentDefinition | undefined {
  const definition = itemDefinitionAtVersion(itemId, definitionVersion);
  return definition?.category === "equipment" ? definition : undefined;
}

export function equipmentAttributesForInstances(
  instances: readonly EquipmentInstanceReference[],
): EquipmentAttributeDefinition[] {
  return instances.flatMap((instance) => {
    const definition = equipmentDefinitionAtVersion(
      instance.itemId,
      instance.definitionVersion,
    );
    return definition
      ? equipmentAttributesForQuality(definition, instance)
      : [];
  });
}

/** Resolves one immutable equipment definition at the quality stored on its instance. */
export function equipmentAttributesForQuality(
  definition: EquipmentDefinition,
  quality: Pick<
    EquipmentInstanceReference,
    "rarity" | "tier" | "enhancementLevel"
  >,
): EquipmentAttributeDefinition[] {
  const rules = itemQualityRules(definition);
  if (
    !rules.rarities.includes(quality.rarity) ||
    !Number.isInteger(quality.tier) ||
    quality.tier < rules.minTier ||
    quality.tier > rules.maxTier ||
    !Number.isInteger(quality.enhancementLevel) ||
    quality.enhancementLevel < 0 ||
    quality.enhancementLevel > rules.maxEnhancement ||
    (quality.rarity === "common" &&
      (quality.tier !== 1 || quality.enhancementLevel !== 0))
  )
    throw new RangeError(`Invalid quality for equipment ${definition.id}`);

  const rarityMultiplier = EQUIPMENT_RARITY_MULTIPLIERS[quality.rarity];
  const tierMultiplier = 1 + 0.1 * (quality.tier - 1);
  const standardMultiplier = rarityMultiplier * tierMultiplier;
  const speedMultiplier = 1 + (standardMultiplier - 1) / 2;
  const isSpeedAttribute = (stat: EquipmentStat): boolean =>
    stat === "movementSpeedPercent" || stat === "attackSpeedPercent";

  return definition.attributes
    .filter((attribute) => {
      const unlockRarity = attribute.unlockRarity ?? "common";
      return (
        RARITY_ORDER.indexOf(quality.rarity) >=
        RARITY_ORDER.indexOf(unlockRarity)
      );
    })
    .map(({ stat, value, unit }) => ({
      stat,
      unit,
      value: Math.round(
        value *
          (isSpeedAttribute(stat) ? speedMultiplier : standardMultiplier) *
          (isSpeedAttribute(stat)
            ? 1 + 0.01 * quality.enhancementLevel
            : 1 + 0.02 * quality.enhancementLevel),
      ),
    }));
}
